"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightRuleNames = exports.InsightEntityType = exports.InsightStatus = void 0;
var InsightStatus;
(function (InsightStatus) {
    InsightStatus["Active"] = "ACTIVE";
    InsightStatus["Canceled"] = "CANCELED";
})(InsightStatus = exports.InsightStatus || (exports.InsightStatus = {}));
var InsightEntityType;
(function (InsightEntityType) {
    InsightEntityType["Commit"] = "COMMIT";
    InsightEntityType["Task"] = "TASK";
    InsightEntityType["PullRequest"] = "PULL_REQUEST";
})(InsightEntityType = exports.InsightEntityType || (exports.InsightEntityType = {}));
var InsightRuleNames;
(function (InsightRuleNames) {
    InsightRuleNames["commitInWrongStatus"] = "Commit while in status";
    InsightRuleNames["prOpenedInWrongStatus"] = "Pull Request opened while in status";
    InsightRuleNames["prMergedInWrongStatus"] = "Pull Request merged while in status";
    InsightRuleNames["setStatusWithCommits"] = "Set status with commits";
    InsightRuleNames["setStatusWithoutCommits"] = "Set status without commits";
    InsightRuleNames["setStatusWithPullRequests"] = "Set status with pull requests";
    InsightRuleNames["setStatusWithoutPullRequests"] = "Set status without pull requests";
    InsightRuleNames["pullRequestMergedWithoutApproval"] = "Pull Request merged without being approved";
    InsightRuleNames["pullRequestInReviewTooLong"] = "Pull Request review stalled";
    InsightRuleNames["rubberStampPullRequestReview"] = "Review possibly rubber stamped";
    InsightRuleNames["pullRequestWithoutActivity"] = "Inactive Pull Request";
    InsightRuleNames["taskWithoutActivity"] = "Task possibly stuck, no work has been recorded";
    InsightRuleNames["pullRequestClosedUnmerged"] = "Closed Pull Request with unmerged work";
    InsightRuleNames["taskTypeMisclassification"] = "Task misclassified";
    InsightRuleNames["pullRequestTooManyReviewCycles"] = "Excessive amount of review cycles";
    InsightRuleNames["unplannedSprintWork"] = "Unplanned Sprint Work";
    InsightRuleNames["taskEstimationChanged"] = "Task effort estimation changed";
})(InsightRuleNames = exports.InsightRuleNames || (exports.InsightRuleNames = {}));
//# sourceMappingURL=insight.js.map